import React from "react";
import { Container, Row, Col, Tab, Tabs } from "react-bootstrap";
import { AiFillMail } from "react-icons/ai";
import { GoLocation } from "react-icons/go";
import { BsTelephoneFill } from "react-icons/bs";
import { FaQuoteLeft } from "react-icons/fa";
import BranchBanner from "../../assets/images/brand/gallery4.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Amenities from "../../components/Amenities";
import Packages from "../../components/Packages";

const Branch = () => {
  const settings = {
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ]
    
  };
  const settingss = {
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ]
  };
  return (
    <>
      <div className="contact">
        <Container>
          <p className="contact__us">Outposts</p>
          <h1>Butwal Branch</h1>
          <p className="contact__desc">
            It is our pleasure to introduce that, The Hotel Pauwa is a homely
            environment with typical Nepalese traditional cultural hotel.
          </p>
          <div className="contact__detail">
            <div>
              <BsTelephoneFill className="icon" />
              <span className="ms-3">+977-9812345678, 071-123456 </span>
            </div>
            <div>
              <AiFillMail className="icon" />
              <span className="ms-3">hotelpauwabutwal@gmail.com</span>
            </div>
            <div>
              <GoLocation className="icon" />
              <span className="ms-3">Yogikuti 3, Rupandehi, Nepal </span>
            </div>
          </div>
        </Container>
      </div>
      <div className="branch">
        <Container>
          <div className="branch__banner">
            <img src={BranchBanner} alt="" />
          </div>
        </Container>
      </div>
      <div className="contact">
        <div style={{ background: "#F9F6EE", padding: "10px 0 40px 0" }}>
          <Container>
            <p className="contact__us">Features</p>
            <h1>Our highlights</h1>
            <p
              className="contact__desc"
              style={{ width: "75%", margin: "35px auto 0 auto" }}
            >
              It is our pleasure to introduce that, The Hotel Pauwa is a homely
              environment with typical Nepalese traditional cultural hotel.
            </p>
            <div className="contact__slider">
              <Row className="gx-2">
                <Slider {...settings}>
                  <Col md={3}>
                    <div>
                      <img src={BranchBanner} alt="" />
                    </div>
                  </Col>
                  <Col md={3}>
                    <div>
                      <img src={BranchBanner} alt="" />
                    </div>{" "}
                  </Col>
                  <Col md={3}>
                    <div>
                      <img src={BranchBanner} alt="" />
                    </div>{" "}
                  </Col>
                  <Col md={3}>
                    <div>
                      <img src={BranchBanner} alt="" />
                    </div>{" "}
                  </Col>
                  <Col md={3}>
                    <div>
                      <img src={BranchBanner} alt="" />
                    </div>{" "}
                  </Col>
                </Slider>
              </Row>
            </div>
          </Container>
        </div>
      </div>
      <div className="branchestab">
        <Container>
          <Tabs
            defaultActiveKey="amenities"
            id="uncontrolled-tab-example"
            className="mb-5"
          >
            <Tab eventKey="amenities" title="Amenities">
              <div>
                <Amenities />
              </div>
            </Tab>
            <Tab eventKey="Rooms & Suites" title="Rooms & Suites">
              <div className="roomdesc">
                <div className="roomdesc__description">
                  <Row className="gx-3">
                    <Col md={6}>
                      <div>
                        <img src={BranchBanner} alt="" />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="roomdesc__description--leftbox">
                        <div className="roomdesc__description--leftbox--heading">
                          <p>Standard Double Room</p>
                          <p>Rs.1500/Night</p>
                        </div>
                        <div className="roomdesc__description--leftbox--about">
                          <p>
                            Facilisis rhoncus id phasellus massa urna, diam
                            volutpat lectus a. Enim duis cras ullamcorper
                            rhoncus diam faucibus. Quisque enim morbi faucibus
                            ultrices bibendum id. Odio mattis ultrices tellus et
                            orci turpis augue. Aliquet tellus sit elit turpis in
                            gravida. Non nullam senectus in iaculis faucibus.
                            Fusce non donec euismod nam elementum lacus et. Nisl
                            phasellus turpis aenean donec dui.
                          </p>
                        </div>
                        <div className="roomdesc__description--leftbox--facility">
                          <p>Rooms Facilities</p>
                          <ul>
                            <li>Flat screen TV</li>
                            <li>Kettle, tea & Coffee</li>
                            <li>Breakfast included</li>
                            <li>Shower-bathtub combination</li>
                            <li>Hairdryer</li>
                            <li>Telephone</li>
                            <li>Towel warmer</li>
                            <li>Fresh mineral water and fresh fruits</li>
                          </ul>
                        </div>
                        <button className='bton bton--md bton--ghost'>
                  Book Now
                </button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="roomdesc">
                <div className="roomdesc__description">
                  <Row className="gx-3">
                    <Col md={6}>
                      <div>
                        <img src={BranchBanner} alt="" />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="roomdesc__description--leftbox">
                        <div className="roomdesc__description--leftbox--heading">
                          <p>Deluxe Honeymoon Room</p>
                          <p>Rs.2500/Night</p>
                        </div>
                        <div className="roomdesc__description--leftbox--about">
                          <p>
                            Facilisis rhoncus id phasellus massa urna, diam
                            volutpat lectus a. Enim duis cras ullamcorper
                            rhoncus diam faucibus. Quisque enim morbi faucibus
                            ultrices bibendum id. Odio mattis ultrices tellus et
                            orci turpis augue. Aliquet tellus sit elit turpis in
                            gravida. Non nullam senectus in iaculis faucibus.
                            Fusce non donec euismod nam elementum lacus et. Nisl
                            phasellus turpis aenean donec dui.
                          </p>
                        </div>
                        <div className="roomdesc__description--leftbox--facility">
                          <p>Rooms Facilities</p>
                          <ul>
                            <li>Flat screen TV</li>
                            <li>Kettle, tea & Coffee</li>
                            <li>Breakfast included</li>
                            <li>Shower-bathtub combination</li>
                            <li>Hairdryer</li>
                            <li>Telephone</li>
                            <li>Towel warmer</li>
                            <li>Fresh mineral water and fresh fruits</li>
                          </ul>
                        </div>
                        <button className='bton bton--md bton--ghost'>
                  Book Now
                </button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Tab>
            <Tab eventKey="Dining" title="Dining">
              <div className="branchestab__dining">
                <Row className="gy-5">
                  <Col md={4}>
                    <div>
                      <img src={BranchBanner} alt="" />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div>
                      <img src={BranchBanner} alt="" />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div>
                      <img src={BranchBanner} alt="" />
                    </div>
                  </Col>
                </Row>
                <p className="branchestab__dining--desc">
                  Nunc, augue convallis felis fringilla cras lorem proin.
                  Eleifend lobortis donec lacus nulla pretium sem elit lacus,
                  laoreet. Ornare elementum pharetra nunc aliquet duis eu
                  bibendum. Faucibus ac tincidunt in tellus enim et. Sem orci
                  consequat arcu est nunc. Nec amet lacus, sed proin fermentum
                  vitae.
                </p>
                <Row>
                  <Col md={4}>
                    <div className="branchestab__dining--left">
                      <p>Dining Area</p>
                      <ul>
                        <li>Luxury Bar (24 px)</li>
                        <li>Summit Lounge (100 px) </li>
                        <li>Pool Bar Restaurant (20 px)</li>
                      </ul>
                    </div>
                  </Col>
                  <Col md={8}>
                    <div className="branchestab__dining--right">
                      <p>Features of Our Dining Area</p>
                      <ul>
                        <li>All Time Music</li>
                        <li>Rooftop Restaurant</li>
                        <li>24hrs Room Service</li>
                        <li>Luxury Bar</li>
                        <li>Private Dining Room</li>
                        <li>Outdoor Dining Space</li>
                        <li>All Day Dining</li>
                        <li>Buffet Breakfast</li>
                        <li>Free High Speed Internet</li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </div>
            </Tab>
            <Tab eventKey="Banquet Hall" title="Banquet Hall">
              <div className="branchestab__banquethall">
                <Packages />
              </div>
            </Tab>
            <Tab eventKey="Reviews" title="Reviews">
              <Row className="gx-5">
                <Slider {...settingss}>
                  <Col sm={12}>
                    <div className="branchestab__reviews">
                      <FaQuoteLeft className="branchestab__reviews--icon" />
                      <p className="branchestab__reviews--review">
                        We list customer quotes as the easiest type of review to
                        get because they involve very little effort for you and
                        your customer. Because you’re in control of adding them
                        to your website, all you need to do is ask your
                        customers. The vendor built their entire customer
                        management software, as well.{" "}
                      </p>
                      <h5>Ericka Lynda</h5>
                      <p className="branchestab__reviews--post">
                        Business Development Officer
                      </p>
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="branchestab__reviews">
                      <FaQuoteLeft className="branchestab__reviews--icon" />
                      <p className="branchestab__reviews--review">
                        We list customer quotes as the easiest type of review to
                        get because they involve very little effort for you and
                        your customer. Because you’re in control of adding them
                        to your website, all you need to do is ask your
                        customers. The vendor built their entire customer
                        management software, as well.{" "}
                      </p>
                      <h5>Ericka Lynda</h5>
                      <p className="branchestab__reviews--post">
                        Business Development Officer
                      </p>
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="branchestab__reviews">
                      <FaQuoteLeft className="branchestab__reviews--icon" />
                      <p className="branchestab__reviews--review">
                        We list customer quotes as the easiest type of review to
                        get because they involve very little effort for you and
                        your customer. Because you’re in control of adding them
                        to your website, all you need to do is ask your
                        customers. The vendor built their entire customer
                        management software, as well.{" "}
                      </p>
                      <h5>Ericka Lynda</h5>
                      <p className="branchestab__reviews--post">
                        Business Development Officer
                      </p>
                    </div>
                  </Col>
                </Slider>
              </Row>
            </Tab>
            <Tab eventKey="View Snapshots" title="View Snapshots">
              <div className="branchestab__photo">
                <Row>
                  <Col md={3}>
                    <figure>
                      <img src={BranchBanner} alt="" />
                    </figure>
                  </Col>
                  <Col md={3}>
                    <figure>
                      <img src={BranchBanner} alt="" />
                    </figure>
                  </Col>
                  <Col md={3}>
                    <figure>
                      <img src={BranchBanner} alt="" />
                    </figure>
                  </Col>
                  <Col md={3}>
                    <figure>
                      <img src={BranchBanner} alt="" />
                    </figure>
                  </Col>
                  <Col md={3}>
                    <figure>
                      <img src={BranchBanner} alt="" />
                    </figure>
                  </Col>
                  <Col md={3}>
                    <figure>
                      <img src={BranchBanner} alt="" />
                    </figure>
                  </Col>
                  <Col md={3}>
                    <figure>
                      <img src={BranchBanner} alt="" />
                    </figure>
                  </Col>
                </Row>
              </div>
            </Tab>
          </Tabs>
        </Container>
      </div>
    </>
  );
};

export default Branch;
